import PaymentMethods from "../../../../content/payment-methods/01-01-available-payment-methods/payment-methods.csv";
import * as React from 'react';
export default {
  PaymentMethods,
  React
};